import Vue from "vue";
import Vuex from "vuex";
import { postData } from "../assets/api/api.js";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        userStudyInfo: {},
        combosData: [],
        timeData: {
            name: "",
            zytime: "",
            zySelectedProgress: "",
            zySelectedTime: "",
            gxtime: "",
            gxSelectedProgress: "",
            gxSelectedTime: "",
        },
        newsId: [],
        master: {
            user: {
                username: "",
            },
            token: {
                token: "",
            },
        },
        isHome: false,
        isCourse: false,
    },
    mutations: {
        setUserStudyInfo(state, info) {
            state.userStudyInfo = info;
        },
        setNews(state, ids) {
            state.newsId = ids;
        },
        setHomeData(state, n) {
            state.HomeData = n;
        },
        setHeadData(state, n) {
            state.HeadData = n;
        },
        setMaster(state, n) {
            state.master = n;
        },
        setIsHome(state, n) {
            state.isHome = n;
        },
        setIsCourse(state, n) {
            state.isCourse = n;
        },
        setTimeData(state, data) {
            state.timeData = data;
        },
        setCombosData(state, data) {
            state.combosData = data;
        },
    },
    actions: {
        getCombosData({ commit, state }, param) {
            return postData("exam/getCombos", param).then((res) => {
                if (res.data) {
                    var data = res.data.map((i) => {
                        if (i.zytime) {
                            i.zyProgress =
                                (i.zytimeNow / i.zytime) * 100 >= 100 ?
                                100 :
                                (i.zytimeNow / i.zytime) * 100;
                        }

                        if (i.gxtime) {
                            i.gxProgress =
                                (i.gxtimeNow / i.gxtime) * 100 >= 100 ?
                                100 :
                                (i.gxtimeNow / i.gxtime) * 100;
                        }
						i.isStudyAll= i.allowExam;
                        // if (i.zytime && i.gxtime) {
                        //     i.isStudyAll =
                        //         i.zytimeNow >= i.zytimeExam && i.gxtimeNow >= i.gxtime;
                        // } else if (i.zytime && !i.gxtime) {
                        //     i.isStudyAll = i.zytimeNow >= i.zytime;
                        // } else if (i.gxtime && !i.xytime) {
                        //     i.isStudyAll = i.gxtimeNow >= i.gxtime;
                        // }
                        return i;
                    });
					for (var i = 0; i < res.data.length; i++) {
						res.data[i]['year'] = res.data[i].name.slice(0, 4);
					}
					data = res.data
					
					// return this.sortKeyDao(data, 'year');
					console.log(data);
                    commit("setCombosData", data);
                } else {
                    commit("setCombosData", null);
                }
                return Promise.resolve(res)
            });
        },
		//倒序
		sortKeyDao(array, key) {
			return array.sort(function(a, b) {
				var x = a[key];
				var y = b[key];
				return ((x > y) ? -1 : (x < y) ? 1 : 0)
			})
		},
        getTimeData({ commit, state }, param) {
            var url = param.tradeNo ?
                "student/getUserComboByTradeno" :
                "student/getUserCombo";
            return postData(url, param).then((res) => {
                if (res.data) {
                    var data = res.data;
                    data.zyStudyTime = res.data.zytimeNow;
                    data.zySelectedTime = res.data.zyTimeSel;
                    data.zySelectedProgress =
                        (res.data.zyTimeSel / res.data.zytime) * 100 > 100 ?
                        100 :
                        (res.data.zyTimeSel / res.data.zytime) * 100;
                    data.zyProgress =
                        (res.data.zytimeNow / res.data.zytime) * 100 > 100 ?
                        100 :
                        (res.data.zytimeNow / res.data.zytime) * 100;
                    data.gxStudyTime = res.data.gxtimeNow;
                    data.gxSelectedTime = res.data.gxTimeSel;
                    data.gxProgress =
                        (res.data.gxtimeNow / res.data.gxtime) * 100 > 100 ?
                        100 :
                        (res.data.gxtimeNow / res.data.gxtime) * 100;
                    data.gxSelectedProgress =
                        (res.data.gxTimeSel / res.data.gxtime) * 100 > 100 ?
                        100 :
                        (res.data.gxTimeSel / res.data.gxtime) * 100;
                    if (res.data.zytime && res.data.gxtime) {
                        if (
                            data.zyStudyTime >= data.zytime &&
                            data.gxStudyTime >= data.gxtime
                        ) {
                            data.isCanTest = true;
                        } else {
                            data.isCanTest = false;
                        }
                    } else {
                        //判断专业课
                        if (res.data.zytime) {
                            if (data.zyStudyTime >= data.zytime) {
                                data.isCanTest = true;
                            } else {
                                data.isCanTest = false;
                            }
                        }
                        //判断公需课
                        if (res.data.gxtime) {
                            if (data.gxStudyTime >= data.gxtime) {
                                data.isCanTest = true;
                            } else {
                                data.isCanTest = false;
                            }
                        }
                    }
                    commit("setTimeData", data);
                } else {
                    commit("setTimeData", null);
                }
            });
        },
        getUserStudyInfo({ commit, state }) {
            return postData("student/getStudentLeanInfo", {}).then((res) => {
                if (res.data) {
                    var zyexchangeTime = +res.data.courseData.zyk.exchangeTime || 0;
                    var gxexchangeTime = +res.data.courseData.gxk.exchangeTime || 0;
                    var zybasepoint = +res.data.zybasepoint || 0;
                    var gxbasepoint = +res.data.gxbasepoint || 0;
                    res.data.courseData.zyk.exchangeTime = zyexchangeTime;
                    res.data.courseData.gxk.exchangeTime = gxexchangeTime;
                    var info = {
                        headimg: res.data.headimg,
                        cztype: res.data.cztype,
                        name: res.data.name,
                        hasCount: 10 - +res.data.examnum || 0, //剩余考试次数
                        examnum: res.data.examnum || 0, //已考次数
                        zybasepoint: zybasepoint, //专业课学分
                        gxbasepoint: gxbasepoint, //公需课学分
                        zyk: res.data.courseData.zyk,
                        gxk: res.data.courseData.gxk,
                    };
                    commit("setUserStudyInfo", info);
                } else {
                    commit("setUserStudyInfo", null);
                }
            });
        },
    },
    modules: {},
});